export default __webpack_public_path__ + "static/testing3-c06f5595a04ad834c76e79f156685807.jpeg";